<template>
  <Modal :is-open="viewBattleModalIsOpen" :closeable="false">
    {{ translation.battle.enterSpectateKey }}
    <input
        type="password"
        v-model="battleViewID"
        placeholder="ID"
        style="width: 30%; left: 25%"
        maxlength="12"
    />
    <br/>
    <br/>

    <div style="display: flex">
      <div>Live:</div>

      <div style="padding: 3px">
        <input type="checkbox" v-model="liveView" style="zoom: 1.5"/>
      </div>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-primary"
          @click="
          viewBattle(battleViewID, liveView);
          viewBattleModalIsOpen = true;
        "
      >
        {{ translation.general.okay }}
      </button>

      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="viewBattleModalIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="SearchPopupModal" :closeable="false">
    <div>{{ translation.battle.waitForPlayer }}</div>
    <div>{{ searchInfoText }}</div>
    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="cancelSearch()"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="RejoinPopupModal" :closeable="false">
    <div>Trying to reconnect to battle...</div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="cancelSearch()"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <Modal :is-open="displayBattleReplayCodes===true" :closeable="false">
    <div v-if="replayCodes.length === 0">
      Can't find replay codes!
    </div>
    <div v-else>
      <div style="display: flex">
        <h5 style="width:60%;"> Battle</h5>
        <h5 style="width:20%;"> Won</h5>
        <h5 style="width:20%;"> Code</h5>

      </div>
      <div v-for="code in replayCodes" :key="code" style="display: flex;">
        <div style="width: 60%;">
          {{ code.loser }} VS {{ code.winner }}
        </div>
        <div style="width: 20%">
          <div v-if="twitch_id === code.winner_id">
            ✅
          </div>
          <div v-else>❌</div>

        </div>
        <div style="width:20%;"> {{ code.unique_battle_key }}</div>

      </div>

    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          v-on:click="displayBattleReplayCodes=false;"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>


  <Modal :is-open="SearchConfirmPopupModal" :closeable="false">
    <div v-if="isRankedMode">{{ translation.battle.wantToBattleRanked }}</div>
    <h4 v-if="isRankedMode">Requirements:</h4>
    <div v-if="isRankedMode">{{ translation.battle.rankedRequirements }}</div>
    <div v-else>{{ translation.battle.wantToBattlePrivate }}</div>

    <div v-if="!isRankedMode" style="margin-top: 10px">
      <input
          :type="passwortInputType"
          v-model="battle_password_input"
          placeholder="Password"
          style="width: 30%; left: 25%"
          maxlength="6"
      />
      <button v-if="isPasswordVisible" @click="togglePasswordVisibility">
        Hide
      </button>
      <button v-else @click="togglePasswordVisibility">
        Show
      </button>
    </div>
    <div v-else>

      <div v-if="allPokemon.length < 6" style="color: red;">
        <br>
        <span>{{ translation.battle.searchBattleNotEnoguh }}</span>
      </div>
    </div>

    <template #footer>
      <button
          :disabled="(isRankedMode && allPokemon.length < 6) || allPokemon.length === 0"
          type="button"
          class="btn btn-primary"
          @click="searchBattle(battle_password_input);"
      >
        {{ translation.general.okay }}
      </button>
      <button
          type="button"
          class="btn btn-secondary"
          @click="SearchConfirmPopupModal = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <InfoPanel
      v-model:is-open="infoPanelIsOpen"
      :current-pokemon="infoPanelCurrentPokemon"
      @pokemon-sold="
      infoPanelIsOpen = false;
      chooseSlotPopupModal = false;
      refreshView();
    "
      @pokemon-nickname-changed="nicknameChanged"
      @wonder-trade="wonderTrade"
      @usedItem="
      async () => {
        await refreshView();
        openInfoPanel(getUpdatedCurrentPokemon(infoPanelCurrentPokemon));
      }
    "
  />

  <ItemModal
      :isOpen="chooseSlotPopupModal"
      :hasInfoButton="true"
      :hasRemoveFromTeamButton="true"
      @removedFromTeam="refreshView()"
      @update:is-item-modal-open="chooseSlotPopupModal = $event"
      @update:is-pokemon-info-open="
      chooseSlotPopupModal = false;
      openInfoPanel(currentPokemon);
    "
      @usedItem="
      async () => {
        await refreshView();
        openInfoPanel(getUpdatedCurrentPokemon(currentPokemon))
      }
    "
      :pokemon="currentPokemon"
  />

  <Modal :is-open="missionRequirementsModalIsOpen" :closeable="false">
    <h3 style="text-decoration: underline">{{ challenge.title }}</h3>
    <h5>Requirements:</h5>
    <div v-for="req in challenge.requirements" :key="req">
      <div>- {{ req }}</div>
    </div>
    <br/>

    <div v-if="challenge.error" style="color: red">{{ challenge.error }}</div>
    <br/>

    <div v-if="challenge" class="col col-6 pr-0 pl-1" style="left: 25%">
      <button
          v-if="challenge.meet_requirements"
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818"
          :disabled="allPokemon.length === 0"
          @click="joinBotBattle('challenge', 'medium')"
      >
        Join challenge!
      </button>
    </div>

    <div v-if="challenge" class="col col-6 pr-0 pl-1" style="left: 12%">
      <button
          v-if="!challenge.meet_requirements"
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818; width: 150%"
          :disabled="true">
        You are not meeting the requirements!
      </button>

      <br/>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="missionRequirementsModalIsOpen = false">
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>


  <Modal :is-open="battleTowerModalIsOpen" :closeable="false">
    <h4 style="text-decoration: underline">Stadium</h4>

    <div>
      Battle with your Team in PvE battles.
    </div>

    <div style="display: flex;justify-content: center;">
      <button
          v-for="difficulty in ['easy', 'medium', 'hard']" :key="difficulty" style="width: 25%;margin:3%;"
          class="btn btn-secondary"
          @click="selectedDifficulty = difficulty"
      >
        {{ difficulty }}
      </button>
    </div>

    <!--    {{ selectedDifficulty }}-->
    <div v-if="battleTower.requirements.length > 0">
      <h5>Requirements:</h5>
      <div v-for="req in battleTower.requirements" :key="req">
        <div>- {{ req }}</div>
      </div>
      <br/>
    </div>

    <div v-if="battleTower.error" style="color: red">{{ battleTower.error }}</div>

    <div v-if="battleTower" class="col col-6 pr-0 pl-1" style="left: 25%">
      <br>
      <button
          v-if="battleTower.meet_requirements"
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818"
          :disabled="allPokemon.length === 0"
          @click="joinBotBattle('stadium', selectedDifficulty)">
        Start ({{ selectedDifficulty }})
      </button>
      <button
          v-else
          class="btn btn-block btn-dark"
          style="padding: 15px; background-color: #dc1818;opacity:0.3;">
        Start ({{ selectedDifficulty }})
      </button>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="battleTowerModalIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </Modal>

  <div v-if="value" :key="value">
    <Multiselect
        style="width: 80%; padding-top: 10px; margin: auto"
        v-model="value"
        :options="options"
        :show-labels="false"
        :searchable="false"
        :allow-empty="false"
        v-bind:placeholder="value.name"
        track-by="id"
        label="name"
        @close="changeActiveTeam(value)"
    />
  </div>

  <div
      v-if="value"
      style="margin-top: 10px; margin-bottom: -15px; margin-left: 10%"
  >
    <h5 @click="startEditTeamname" id="pokemonNickname">{{ value.name }}</h5>
    <input
        style="width: 60%"
        type="text"
        id="pokemonNicknameInput"
        name="pokemonName"
        class="d-none"
        v-bind:value="value.name"
        @change="updateTeamName()"
    />
  </div>

  <div class="row p-4">
    <div
        class="col-4 pokemon-list__entry"
        v-for="pokemon in allPokemon"
        v-bind:key="pokemon.id"
    >
      <PokemonEntryButton
          :pokedex-id="pokemon.pokedexId"
          :id="pokemon.id"
          :name="pokemon.name"
          :is-shiny="pokemon.isShiny"
          :sell-price="pokemon.sellPrice"
          :lvl="pokemon.lvl"
          :hpPercent="pokemon.hpPercent"
          :team-slot="pokemon.teamSlot"
          :status-effect="pokemon.statusEffect"
          :public-battle-banned="pokemon.publicBattleBanned"
          :special-variant="pokemon.specialVariant"
          @click="
          currentPokemon = pokemon;
          chooseSlotPopupModal = true;
        "
          @contextmenu.prevent="removeFromTeam(pokemon)"
      />
    </div>
  </div>

  <div style="margin:auto;width:70%;">
    <button
        class="btn btn-block btn-dark" style="margin:3px;color:white; background-color: #dc1818"
        @click="showRankingLeaderboard()">
      Leaderboard (Wins: {{ wins }} Losses: {{ loses }})
      Season {{ season }} (Wins: {{ seasonWins }} Losses: {{ seasonLoses }})
    </button>
  </div>

  <div v-if="allPokemon.length > 0">
    <div v-for="tourney in tourneys" :key="tourney">

      <div style="width:88%;margin:auto;border: 1px solid #dee2e6;padding: 6px;">

        <div>
          <h4>{{ tourney.host }}'s tourney</h4>

          <span>{{ tourney.round }}</span><br>

          <span v-if="tourney.opponent_username">Opponent: {{ tourney.opponent_username }}</span><br>

          <span v-if="tourney.RoundReadySince">Round ready since: {{ tourney.RoundReadySince }}</span><br>

          <br>
          <h5>Rules</h5>
          <span>Duplicates allowed: {{ tourney.duplicates }}</span><br>
          <span v-if="tourney.max_base_stats < 999">Max BST: {{ tourney.max_base_stats }}<br></span>
          <span v-if="tourney.rules.length > 1">{{ tourney.rules }}</span><br>

          <button
              v-if="tourney.opponent_username"
              class="btn btn-block btn-primary"
              style="padding: 15px;height:80px;"
              @click="searchBattle(tourney.key)">
            {{ translation.battle.searchTourneyBattle(tourney.opponent_username) }}
          </button>
          <button
              v-else
              class="btn btn-block btn-secondary"
              style="padding: 15px;height:80px;"
              disabled="disabled">
            {{ translation.battle.searchTourneyBattleNotReady }}
          </button>
        </div>


      </div>
      <br>

    </div>
  </div>

  <div>

    <div style="display: flex;width:90%;margin:auto;height:60px;margin-top: 6px;">
      <button class="btn btn-dark" :style="pcgSecondaryThemeStyle"
              style="width:49%;margin:3px;"
              :disabled="!enableRankedButton"
              @click="isRankedMode=true;SearchConfirmPopupModal = true">
        {{ translation.battle.searchBattleRanked }} ({{ currentMMR }})
        <img :src="imageUri + 'static/twitchextension/ranks/' +  currentRank +'.png'" style="width: 5vh;height:5vh;">
      </button>

      <button class="btn btn-dark" :style="pcgSecondaryThemeStyle" style="width:49%;margin:3px;"
              :disabled="!enableCasualButton"
              @click="isRankedMode=false;SearchConfirmPopupModal = true">
        Private
        <svg style="width:24px;height:24px;" viewBox="0 0 24 24">
          <path fill="currentColor" d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z"/>
        </svg>
      </button>
    </div>


    <div style="display: flex;width:90%;margin:auto;height:60px;">
      <button v-if="challenge" class="btn btn-block btn-dark"
              style="width:49%;margin:3px;color:white;background-color: #dc8e18"
              @click="missionRequirementsModalIsOpen = true">
        {{ challenge.name }}
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z"/>
        </svg>
      </button>
      <button v-else class="btn btn-block btn-dark" disabled
              style="width:49%;margin:3px;color:white;background-color: #dc8e18; opacity: 0.2;">
        No Challenge
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z"/>
        </svg>
      </button>

      <br/>


      <button v-if="battleTower"
              class="btn btn-block btn-dark" style="width:49%;margin:3px;color:white; background-color: #dc8e18"
              @click="battleTowerModalIsOpen = true">
        Stadium
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19A2,2 0 0,0 13,17H11A2,2 0 0,0 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z"/>
        </svg>
      </button>
      <button v-else disabled
              class="btn btn-block btn-dark"
              style="width:49%;margin:3px;color:white; background-color: #dc8e18; opacity: 0.2;">
        Stadium
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19A2,2 0 0,0 13,17H11A2,2 0 0,0 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z"/>
        </svg>
      </button>
      <br/>
    </div>
  </div>

  <div style="width: 45%; margin: auto; padding-top: 10px;display: flex;">
    <button :style="pcgSecondaryThemeStyle"
            class="btn btn-block btn-dark"
            style="padding: 5px"
            @click="viewBattleModalIsOpen = true">
      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
        />
      </svg>
    </button>

    <div style="width: 14%;"></div>

    <button :style="pcgSecondaryThemeStyle"
            class="btn btn-block btn-dark"
            style="padding: 5px"
            @click="displayBattleReplayCodes = true">
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="currentColor"
              d="M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3A9,9 0 0,0 4,12H1L4.96,16.03L9,12H6A7,7 0 0,1 13,5A7,7 0 0,1 20,12A7,7 0 0,1 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21A9,9 0 0,0 22,12A9,9 0 0,0 13,3"/>
      </svg>
    </button>
  </div>

  <br>
  <div v-if="twitch_id === '80629581' "
       class="col col-6 pr-0 pl-1"
       style="left: 25%; margin-top: 15px">
    <button
        class="btn btn-block btn-dark"
        style="padding: 15px; background-color: #dc1818"
        @click="autoPlayBattles = true;currentView = BattleWatchQueue;;">
      Spectate channel
    </button>
    <br/>
  </div>

</template>

<script>
import ItemModal from "../../components/ItemModal/ItemModal.vue";
import {translation} from "@/utils/translations";
import {backendUri, battleUri} from "@/utils/settings";
import axios from "axios";
import {ref} from "@vue/reactivity";
import {showModalMsg} from "@/components/Modal/modalUtils";
import Modal from "@/components/Modal/Modal";
import {battleContent, currentView} from "@/utils/globals";
import PokemonEntryButton from "@/components/PokemonEntryButton/PokemonEntryButton";
import {
  startLoadingProcess,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {onMounted} from "@vue/runtime-core";
import Battle from "@/views/Battle/Battle";
import Multiselect from "vue-multiselect";
import {handleUnknownError, sort_by} from "@/utils/utilities";
import $ from "jquery";
import {PCGApi} from "../../services/pcg";
import InfoPanel from "../PokemonList/InfoPanel";
import {pcgSecondaryThemeStyle, twitch_id, autoPlayBattles} from "../../utils/globals";
import Ranking from "../Ranking/Ranking";
import {battleSocketUri, imageUri} from "../../utils/settings";
import BattleWatchQueue from "./BattleWatchQueue.vue";

export default {
  name: "BattleSlotPanel",
  components: {
    Modal,
    PokemonEntryButton,
    Multiselect,
    InfoPanel,
    ItemModal,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    currentItem: {
      type: Object,
    },
  },
  data() {
    return {
      checked: false,
      battle_password_input: "",
      liveView: false,
      battleViewID: ""
    };
  },
  watch: {
    battle_password_input(newValue) {
      const alphanumeric = newValue.replace(/[^a-zA-Z0-9]/g, '');
      if (alphanumeric !== newValue) {
        this.battle_password_input = alphanumeric;
      }
    }
  },
  setup() {
    let value = ref({"name": null, "id": null});
    let options = ref([]);
    const missionRequirementsModalIsOpen = ref(false);
    const battleTowerModalIsOpen = ref(false);
    const viewBattleModalIsOpen = ref(false);
    const enableRankedButton = ref(true);
    const enableCasualButton = ref(true);
    const displayBattleReplayCodes = ref(false);
    const replayCodes = ref();
    const selectedDifficulty = ref("medium");

    const isRankedMode = ref(false);
    const currentRank = ref("");
    const currentMMR = ref(1000);
    const loses = ref(0);
    const wins = ref(0);
    const seasonWins = ref(0);
    const seasonLoses = ref(0);
    const season = ref("X");
    const challenge = ref();
    const battleTower = ref();
    const currentPokemon = ref();
    const currentSelectedItem = ref();
    const allPokemon = ref([]);
    const tourneys = ref([]);

    const joinBotBattle = async (mode, difficulty) => {
      startLoadingProcess();
      await axios
          .post(battleUri + "api/game/ext/battle/search/bot/", {
            mode: mode,
            difficulty: difficulty,
            teamID: value.value.id
          })
          .then(() => {
            currentView.value = Battle;
            stopLoadingProcess();
          })
          .catch((error) => {
            if (error.response.data.error === 14) {
              showModalMsg(translation.battle.tooManyConcurrentBattles);
            } else {
              handleUnknownError(error);
            }
          });
    };

    const changeActiveTeam = async (team) => {
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-change-active-team/", {
            team_id: team.id,
          })
          .then(() => {
            refreshView();
          })
          .catch((error) => {
            handleUnknownError(error);
          });
    };

    let nickname = ref("");
    const updateTeamName = async () => {
      nickname.value = $("#pokemonNicknameInput").val();
      await axios
          .post(
              backendUri +
              "api/game/ext/trainer/change-teamname/" +
              value.value.id +
              "/",
              {nickname: nickname.value}
          )
          .then((resp) => {
            nickname.value = resp.data.nickname;
            $("#pokemonNickname").text(nickname.value);

            value.value["name"] = nickname.value;

            $("#pokemonNickname").removeClass("d-none");
            $("#pokemonNicknameInput").addClass("d-none");
          })
          .catch((error) => {
            if (error.response.data.error === 2) {
              showModalMsg(translation.pokemonList.PokemonNicknameTooLong);
            } else {
              handleUnknownError(error);
            }
          });
    };

    const startEditTeamname = async () => {
      $("#pokemonNicknameInput").removeClass("d-none");
      $("#pokemonNickname").addClass("d-none");
    };

    const refreshView = async () => {
      startLoadingProcess();
      await axios
          .get(battleUri + "api/game/ext/battle/check_if_rejoinable/")
          .then((resp) => {
                tourneys.value = resp.data.tourneys;
                replayCodes.value = resp.data.replayCodes
                if (resp.data.rejoinableBattle) {
                  RejoinPopupModal.value = true;
                  searchBattle('');
                }

              }
          );

      await axios
          .get(backendUri + "api/game/ext/trainer/pokemon-team-list/")
          .then((resp) => {
            allPokemon.value = resp.data.allPokemon;
            allPokemon.value.sort(sort_by("teamSlot", false));

            wins.value = resp.data.wins;
            loses.value = resp.data.loses;

            season.value = resp.data.season;
            seasonWins.value = resp.data.seasonWins;
            seasonLoses.value = resp.data.seasonLoses;

            currentMMR.value = resp.data.currentMMR
            currentRank.value = resp.data.rank

            challenge.value = resp.data.challenge;

            battleTower.value = resp.data.stadium;
            enableRankedButton.value = resp.data.enableRankedButton
            enableCasualButton.value = resp.data.enableCasualButton

            options.value = [];
            for (let i = 0; i < resp.data.teamNames.length; i++) {
              options.value.push({id: i, name: resp.data.teamNames[i]});
            }
            value.value = options.value[resp.data.teamNumber];
          })
          .catch((error) => {
            handleUnknownError(error);
          });

      stopLoadingProcess();
    };

    onMounted(() => {
      refreshView();
    });

    const removeFromTeam = async (pkm) => {
      startLoadingProcess();
      await axios
          .post(backendUri + "api/game/ext/trainer/pokemon-remove-team/", {
            pokemon_id: pkm.id,
          })
          .then(() => {
            refreshView();
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.pokemonList.PokemonNotInTeam);
            } else {
              handleUnknownError(error);
            }
          });
      stopLoadingProcess();
    };

    // battle
    let searchInfoText = ref("");
    let chooseSlotPopupModal = ref(false);

    let SearchPopupModal = ref(false);
    let RejoinPopupModal = ref(false);
    let SearchConfirmPopupModal = ref(false);


    const cancelSearch = async () => {
      queueSocketShouldReconnect.value = false;
      queueSocket.close()
    };

    const viewBattle = async (battleViewID, liveView) => {
      if (battleViewID === undefined || battleViewID === null) {
        showModalMsg(translation.battle.battleDoesntExist);
        return;
      }
      if (battleViewID.length < 4) {
        showModalMsg(translation.battle.battleDoesntExist);
        return;
      }

      battleContent.value = {
        isViewer: true,
        liveView: liveView,
        id: battleViewID,
        speed: 0.5,
        "paused": false
      };
      currentView.value = Battle;
    };

    function sendPing() {
      if (queueSocket && queueSocket.readyState === WebSocket.OPEN) {
        queueSocket.send(JSON.stringify({type: 'ping'}));

        // Expect a pong back within 10 seconds
        pingPongTimeout = setTimeout(() => {
          queueSocket.close();
        }, 10000);
      }
    }

    let queueSocket;
    let pingPongTimeout;
    let pingIntervalId;
    const queueSocketShouldReconnect = ref(true);
    // let reconnectTimeout = 3000; // Initial timeout of 3 seconds
    // const MAX_TIMEOUT = 60000 * 5; // Maximum timeout of 5 minutes
    const searchBattle = async (password) => {
      SearchConfirmPopupModal.value = false;
      SearchPopupModal.value = true;

      queueSocketShouldReconnect.value = true;
      let socket_url = "wss://" + battleSocketUri + '/ws/battle/queue/' +
          "?Authorization=" + axios.defaults.headers.common["Authorization"] +
          '&password=' + password +
          '&ranked=' + isRankedMode.value +
          '&teamID=' + value.value.id;
      queueSocket = new WebSocket(socket_url);


      queueSocket.onmessage = function (e) {
        const data = JSON.parse(e.data);

        if (data.type === 'pong') {
          clearTimeout(pingPongTimeout);
          return;
        }


        if (data.action === 'start_match') {
          SearchPopupModal.value = false;
          currentView.value = Battle;
          queueSocketShouldReconnect.value = false;
          queueSocket.close()
        } else if (data.action === 'info') {
          searchInfoText.value = data.content;
        } else if (data.action === 'error') {
          showModalMsg(data.content);
          queueSocketShouldReconnect.value = false;
          queueSocket.close()
        }
      }


      queueSocket.onopen = function () {
        // Reset the reconnect timeout once the connection is successfully established
        // reconnectTimeout = 3000;
        sendPing();

        // Start pinging the server every 30 seconds
        pingIntervalId = setInterval(sendPing, 1000 * 30);

      }

      queueSocket.onclose = function () {
        clearInterval(pingIntervalId);

        SearchPopupModal.value = false;
        RejoinPopupModal.value = false;
        if (queueSocketShouldReconnect.value) {
          showModalMsg('You lost connection. Please ensure that you have a stable connection and join the queue again!');
        }

      }
    }


    const infoPanelIsOpen = ref(false);
    const infoPanelCurrentPokemon = ref({});

    const openInfoPanel = async (pkm) => {
      startLoadingProcess();
      try {
        const pokeInfo = await PCGApi.Trainer.getTrainerPokeInfo(pkm.id);

        infoPanelIsOpen.value = true;
        infoPanelCurrentPokemon.value = {
          ...pkm,
          ...pokeInfo,
        };
      } catch (error) {
        if (error.response.data.error === 10) {
          showModalMsg(translation.pokemonList.sellNotExists);
        } else {
          handleUnknownError(error);
        }
      }

      stopLoadingProcess();
    };

    const nicknameChanged = (_id, newName) => {
      currentPokemon.value.name = newName;
    };

    const showRankingLeaderboard = () => {
      currentView.value = Ranking;
    };

    const wonderTrade = async (pokemon) => {
      chooseSlotPopupModal.value = false;
      infoPanelIsOpen.value = false;
      await refreshView();
      openInfoPanel(pokemon);
    };

    const getUpdatedCurrentPokemon = (pokemon) => {
      console.debug(pokemon)
      const instance = allPokemon.value.find((x) => x.id === pokemon.id);

      console.debug(instance);

      return instance;
    };

    const isPasswordVisible = ref(false);
    const passwortInputType = ref('password');

    function togglePasswordVisibility() {
      isPasswordVisible.value = !isPasswordVisible.value;

      if (isPasswordVisible.value) {
        passwortInputType.value = 'text';
      } else {
        passwortInputType.value = 'password';
      }
    }

    return {
      refreshView,
      translation,
      SearchConfirmPopupModal,
      searchBattle,
      cancelSearch,
      removeFromTeam,
      viewBattle,
      SearchPopupModal,
      chooseSlotPopupModal,
      allPokemon,
      currentPokemon,
      changeActiveTeam,
      viewBattleModalIsOpen,
      currentSelectedItem,
      value,
      options,
      startEditTeamname,
      updateTeamName,
      joinBotBattle,
      challenge,
      missionRequirementsModalIsOpen,
      openInfoPanel,
      infoPanelIsOpen,
      infoPanelCurrentPokemon,
      nicknameChanged,
      wonderTrade,
      getUpdatedCurrentPokemon,
      RejoinPopupModal,
      currentMMR,
      isRankedMode,
      pcgSecondaryThemeStyle,
      battleTower,
      battleTowerModalIsOpen,
      wins,
      loses,
      autoPlayBattles,
      twitch_id,
      showRankingLeaderboard,
      enableRankedButton,
      enableCasualButton,
      displayBattleReplayCodes,
      replayCodes,
      imageUri,
      currentRank,
      selectedDifficulty,
      currentView,
      BattleWatchQueue,
      season,
      seasonWins,
      seasonLoses,
      tourneys,
      searchInfoText,
      togglePasswordVisibility,
      isPasswordVisible,
      passwortInputType

    };
  },
};
</script>

<style lang="scss" scoped>
.pokemon-list {
  &__entry {
    padding: 0;
    margin-bottom: 20px;
  }
}

.key-password-button {
  transform: rotate(-135deg);
  transition: all 500ms ease;

  &:hover {
    transform: rotate(-45deg);
  }
}

.add-to-team {
  transition: all 600ms ease;
  transform: rotate(0deg);

  width: 68px;
  height: 68px;

  svg {
    position: absolute;
    top: 12px;
    left: 0;
    transition: all 600ms ease;
  }

  &:hover &-svg {
    transform: rotate(90deg);
  }
}
</style>
